// src/screens/levels/A1/TypeImages.ts

const typeImages: Record<string, string> = {
    Alphabet: require('./images/alphabet.png'),
    Zahlen: require('./images/zahlen.png'),
    Farben: require('./images/colors.png'),
    Tage: require('./images/days.png'),
    Monate: require('./images/months.png'),
    Jahreszeiten: require('./images/seasons.png'),
    Uhrzeit: require('./images/time.png'),
    Wetter: require('./images/weather.png'),
    Familie: require('./images/family.png'),
    Körperteile: require('./images/body.png'),
    Kleidung: require('./images/clothes.png'),
    Gefühle: require('./images/emotions.png'),
    Berufe: require('./images/profession.png'),
    Essen: require('./images/food.png'),
    Getränke: require('./images/drinks.png'),
    Obst: require('./images/fruits.png'),
    Gemüse: require('./images/vegetables.png'),
    Möbel: require('./images/furniture.png'),
    Verkehr: require('./images/transport.png'),
    Richtungen: require('./images/directions.png'),
    Hobbys: require('./images/hobbies.png'),
    Sport: require('./images/sports.png'),
    Tiere: require('./images/animals.png'),
    Vögel: require('./images/birds.png'),
  };
  
  export default typeImages;
  